import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b99c410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "home-page__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-page__header-images" }, null, -1))
const _hoisted_4 = { class: "home-page__title" }
const _hoisted_5 = { class: "home-page__descr" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "home-page__section" }
const _hoisted_8 = { class: "home-page__section-title" }

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Numbers from '@/views/home/Numbers.vue';
import Apps from '@/views/home/Apps.vue';
import Advantages from '@/views/home/Advantages.vue';
import Steps from '@/views/home/Steps.vue';
import CustomerReviews from '@/components/CustomerReviews.vue';
import SearchForm from '@/components/SearchForm.vue';
import BottomSection from './BottomSection.vue';

import { Review } from '@/@types/bankroll';


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const store = useStore();
const router = useRouter();

const searchPlants = (searchStr: string) => {
  store.dispatch('plant/setSearchPlantsResult', []);

  router.push({
    name: 'SearchResults',
    query: { plant: searchStr },
  });
};
const customerReviews = computed<Review[]>(
  () => store.state.pricing.customerReviews
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('page_home_title')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('page_home_subtitle')), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(SearchForm, {
          class: "home-page__search",
          onSearch: searchPlants
        })
      ])
    ]),
    _createVNode(Numbers),
    _createVNode(Apps),
    _createVNode(Advantages),
    _createVNode(Steps),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('page_membership_reviews_title')), 1),
      _createVNode(CustomerReviews, { reviews: _unref(customerReviews) }, null, 8, ["reviews"])
    ]),
    _createVNode(BottomSection)
  ]))
}
}

})